import {
  Box,
  Button,
  Typography,
  useTheme,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import WrongWalletImage from "../../assets/images/wrongWallet.svg";
import { useHistory } from "react-router";

const useStyle = makeStyles((theme) => ({
  root: {
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
    border: "solid 2px rgba(62, 184, 170, 1)",
    borderRadius: "1rem",
    position: "relative",
    height: "27.5rem",
    zIndex: 100,
    background: "rgba(255, 255, 255, 0.75)",
    backdropFilter: "blur(100px)",

    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: "inherit", // Make sure it follows the same rounded corners
      boxShadow: "inset 70px 140px 134px rgba(39, 105, 98, 0.1)", // Inner shadow effect
      pointerEvents: "none", // Allow interaction with elements inside
    },

    [theme.breakpoints.up("lg")]: {
      minWidth: "46rem",
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: "100%",
     
    },
    [theme.breakpoints.down("xs")]: {
      width: "90%",
    },
  },
  lock: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "3.2rem",
    height: "2.6rem",
    borderTopRightRadius: "0.85rem",
    borderBottomLeftRadius: ".75rem",
    backgroundColor: "rgba(62, 184, 170, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {},
  title: {
    fontSize: "1.625rem",
    color: "rgba(17, 48, 45, 1)",
    fontWeight: 700,
    margin: "1.5rem 0 1rem 0",
  },
  addressBtn: {
    display: "flex",
    padding: "0.5rem",
    border: "0.7px solid rgba(62, 184, 170, 0.5)",
    borderRadius: "100px",
    margin: "1rem 0",
  },
  connect: {
    width: "209px",
    maxWidth: "60%",
    marginTop: "2.5rem",
    minHeight: "3rem",
  },
}));

export default function MaxContribution() {
  const classes = useStyle();
  const theme = useTheme();
  const history = useHistory();

  const handleClick = () => {
    history.push("/deals");
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.lock}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 2.25C9.23858 2.25 7 4.48858 7 7.25V9.07501C5.28832 9.42247 4 10.9358 4 12.75V18.25C4 20.3211 5.67893 22 7.75 22H16.25C18.3211 22 20 20.3211 20 18.25V12.75C20 10.9358 18.7117 9.42247 17 9.07501V7.25C17 4.48858 14.7614 2.25 12 2.25ZM15.5 9V7.25C15.5 5.317 13.933 3.75 12 3.75C10.067 3.75 8.5 5.317 8.5 7.25V9H15.5ZM12 13.25C12.4142 13.25 12.75 13.5858 12.75 14V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V14C11.25 13.5858 11.5858 13.25 12 13.25Z"
            fill="#11302D"
          />
        </svg>
      </Box>
      <img src={WrongWalletImage} className={classes.icon} alt="wrong wallet" />
      <Typography className={classes.title}>You invested the max amount</Typography>
      <Typography variant="body1">
        If we extend the max cap, you will be notified with an email.
      </Typography>
      <Button
        variant="contained"
        color="secondary"
        classes={{ label: "fs12" }}
        className={classes.connect}
        onClick={handleClick}
        endIcon={
          <svg
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.33333 1.83334L12.5 6.00001L8.33333 10.1667M12 6.00001H1.5"
              stroke="#24E9C0"
              stroke-width="2"
              stroke-linecap="square"
            />
          </svg>
        }
      >
        See other deals
      </Button>
    </Box>
  );
}
